// PROTOTYPE
// This Component is highly subject to change
import React from 'react'
import { css, keyframes } from 'emotion'
import PropTypes from 'prop-types'
import ScrollView from 'src/components/utils/ScrollView'

const fadeIn = keyframes`
  0% {
    background-color: rgba(0,0,0,0);
  }

  50% {
    background-color: rgba(0,0,0,0.07);
  }

  100% {
    background-color: rgba(0,0,0,0.01);
  }
`

const ProtoColumnB = ({ children }) => (
   <ScrollView
      className={css`
         background-color: rgba(0,0,0,0.01);
         animation: ${fadeIn} 2s ease;
      `}
      position="absolute"
      top="0px"
      left="0px"
      width="auto[a-d] 300px[e-f]"
      bottom="0px"
      right="0px[a-d] auto[e-f]"
      borderRight="1px solid rgba(0,0,0,0.05)[e-f]"
      scroll="on">
      {children}
   </ScrollView>
)

ProtoColumnB.propTypes = {
   children: PropTypes.node.isRequired
}

export default ProtoColumnB
